import { AsyncPipe, NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { delay } from 'rxjs';

import { UaService } from '@ecm/consumer';
import { TitleService } from '@ecm/router';

import { MenuViewModel } from '../../model/menu.view-model';
import { MenuStoreService } from '../../store/menu-store.service';

@Component({
    selector: 'ecm-sosh-menu',
    templateUrl: 'sosh-menu.html',
    styleUrls: ['sosh-menu.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [NgTemplateOutlet, RouterLink, AsyncPipe, TranslateModule],
})
export class SoshMenuComponent implements OnInit, OnDestroy {
    public menus$ = this.menuStore.menus$;

    public showBack$ = this.menuStore.showBack$.pipe(delay(0));

    public title$ = this.titleService.getTitle().pipe(delay(0));

    public isMobile = this.uaService.isMobile();

    public constructor(
        private menuStore: MenuStoreService,
        private titleService: TitleService,
        private uaService: UaService,
    ) {}

    public ngOnInit(): void {
        this.menuStore.enter();
    }

    public ngOnDestroy(): void {
        this.menuStore.leave();
    }

    public selectMenuItem(menu: MenuViewModel) {
        this.menuStore.selectMenuItem(menu);
    }

    public navigateToBackRoute() {
        this.menuStore.navigateToBackRoute();
    }
}
